"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".ce1319d20{align-items:center;background:#fff;border-radius:var(--border-radius-def);font-size:1rem;font-weight:400;line-height:1.125rem;min-height:2.625rem;box-sizing:border-box}.ca9e0b4af{display:flex}.ce74f457f{display:inline-flex}.c80dcfaf5{padding:.4375rem 1.5625rem}.c3c30bd85{padding:.4375rem .6875rem}");
var styles = {
  root: 'ce1319d20',
  '--width-block': 'ca9e0b4af',
  '--width-content': 'ce74f457f',
  '--padding-usual': 'c80dcfaf5',
  '--padding-small': 'c3c30bd85'
};

var ActionBlock = function ActionBlock(props) {
  var children = props.children,
      classes = props.classes,
      width = props.width,
      padding = props.padding;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.width[width], cn.padding[padding])
  }, children);
};

exports.ActionBlock = ActionBlock;
var padding = ['usual', 'small'];
var width = ['block', 'content'];
ActionBlock.modes = {
  padding: padding,
  width: width
};
ActionBlock.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  width: (0, _propTypes.oneOf)(width),
  padding: (0, _propTypes.oneOf)(padding),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ActionBlock.defaultProps = {
  width: 'block',
  padding: 'usual',
  classes: {}
};